<template>
  <div class="jobsAdd">
    <div class="ruleForm" style="margin-top: 0;width: 100%;">
      <el-form
        :model="info"
        :rules="rules"
        ref="info"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item label="工厂" class="s-form-item" prop="companyname">
          <el-select v-model="info.companyname" placeholder="请选择工厂">
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :value="item.companyname"
              @click.native="chooseCompany(item.id, item.companyname)"
              >{{ item.companyname }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" class="s-form-item">
          <el-input v-model="info.department"></el-input>
        </el-form-item>
        <div>
          <el-form-item label="职位名称" prop="jobs_name" class="s-form-item">
            <el-input v-model="info.jobs_name"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="职位类别" prop="category" class="s-form-item">
          <el-cascader
            v-model="info.category"
            :options="categoryList"
            ref="cascaderJobType"
            @change="handlecategory"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'categoryname',
              children: 'data',
            }"
          ></el-cascader>
        </el-form-item>
       <el-form-item label="工作类型" prop="nature" class="s-form-item">
         <div class="natureItems_box">
           <div
             :class="['natureItems', info.nature == item[0] ? 'active' : '']"
             v-for="(item, index) in natureList"
             :key="index"
             @click="natureChoose(item[0], item[1])"
           >
             {{ item[1] }}
           </div>
         </div>
       </el-form-item>

        <el-form-item label="招聘人数" prop="amount" class="s-form-item">
          <el-input type="number" v-model="info.amount"></el-input>
        </el-form-item>
        <el-form-item label="工作地点" prop="district" class="s-form-item">
          <el-cascader
            v-model="info.district"
            :options="locationList"
            ref="cascaderAddr"
            @change="handleChange"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'categoryname',
              children: 'data',
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address" class="s-form-item">
          <el-input v-model="info.address"></el-input>
        </el-form-item>

        <el-form-item label="职位描述" prop="contents" class="s-form-item">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="info.contents"
          >
          </el-input>
        </el-form-item>
        <div class="age s-form-item">
          <el-form-item label="年龄要求" prop="minage">
            <el-input
              v-model="info.minage"
              placeholder="最低年龄"
              onblur="if(value<16)value=16"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item prop="maxage">
            <el-input
              v-model="info.maxage"
              placeholder="最高年龄"
              onblur="if(value<16)value=16"
              type="number"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="学历要求" class="s-form-item">
          <el-select v-model="info.education_cn" placeholder="学历要求">
            <el-option
              v-for="(item, index) in educationList"
              :key="index"
              :value="item[1]"
              @click.native="EduChoosen(item[0], item[1])"
              >{{ item[1] }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item label="经验要求" class="s-form-item">
          <el-select v-model="info.experience_cn" placeholder="经验要求">
            <el-option
              v-for="(item, index) in experienceList"
              :key="index"
              :value="item[1]"
              @click.native="ExpChoosen(item[0], item[1])"
              >{{ item[1] }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item label="薪资福利" v-if="!/兼职|临时工/.test(nature_cn)"  class="s-form-item">
          <div>
            <el-switch v-model="face" @change="handleswitch"></el-switch>&nbsp;
            <span>面议</span>
          </div>
        </el-form-item>
        <div v-if="face == false" class="wages s-form-item" style="width: 700px;">
          <el-form-item
            label="最低薪资"
            prop="minwage"
            :rules="[{ required: !face, message: '最低薪资', trigger: 'blur' }]">
            <el-input
              v-model="info.minwage"
              placeholder="最低薪资"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="maxwage"
            label="最高薪资"
            :rules="[{ required: !face, message: '最高薪资', trigger: 'blur' }]"
          >
            <el-input
              v-model="info.maxwage"
              placeholder="最高薪资"
              type="number"
            ></el-input>
          </el-form-item>
          <div
            style="width: 400px; margin-left: 50px; margin-bottom: 22px"
            v-if="/兼职|临时工/.test(nature_cn)">
          <el-select v-model="waydate.cn" placeholder="请选择结算方式">
            <el-option
              v-for="(item, index) in waydate.list"
              :key="index"
              :value="item.name"
              @click.native="waydateClick(index)"
              >{{item.name }}</el-option
            >
          </el-select>
          </div>
        </div>
        <div v-if="/兼职|临时工/.test(nature_cn)" class="wage s-form-item">
          <el-form-item label="结算方式">
            <el-select v-model="settlement.cn" placeholder="请选择结算方式">
            <el-option
              v-for="(item, index) in settlement.list"
              :key="index"
              :value="item.name"
              @click.native="settlementClick(index)"
              >{{item.name }}</el-option
            >
          </el-select>
          </el-form-item>
        </div>
        <div v-if="!/兼职|临时工/.test(nature_cn)">
          <el-form-item label="满勤"  class="s-form-item">
            <el-input v-model="info.workfulldays"></el-input>
          </el-form-item>
          <el-form-item label="月休"  class="s-form-item">
            <el-input v-model="info.restdays"></el-input>
          </el-form-item>
        </div>

<!--        <el-form-item label="代理价格"  class="s-form-item">
          <el-input type="number" v-model="info.agentprice" placeholder="请输入代理价格,元/时"></el-input>
        </el-form-item>
        <el-form-item label="收费时长"  class="s-form-item">
          <el-input type="number" v-model="info.feelong" placeholder="请输入收款天数"></el-input>
        </el-form-item> -->
        <el-form-item label="合同台账"  class="s-form-item">
          <el-select v-model="info.contract_id">
            <el-option
              v-for="(item, index) in contractList"
              :key="index"
              :value="item.id"
              :label="item.companyname+'-'+item.contract_type_cn"
              ></el-option>

          </el-select>
        </el-form-item>

        <el-form-item class="s-form-item"
          label="福利待遇"
          :rules="[{ required: true, message: '福利待遇', trigger: 'change' }]" >
          <div class="welfare">
            <el-input
              v-model="info.checkedTags_cn"
              placeholder="点击选择福利待遇"
              @focus="tagsClick"
            ></el-input>

          </div>
        </el-form-item>

        <el-form-item label="环境图片"  class="s-form-item">
          <div>

              <MyUpload
                :dataSource="info.imgwork"
                :upload-multiple="true"
                :upload-para="uploadPara"
                @change="(url) => uploadImgSuccess(url, 'imgwork')"
              />


          </div>
        </el-form-item>
        <el-form-item label="招聘话术:" >
          <div style="display: flex;margin-bottom: 5px;">
            <el-form-item label="岗位要求:" class="s-form-item">
              <el-input type="textarea" :rows="5" v-model="speechcraftArr.jobDemand"></el-input>
            </el-form-item>
            <el-form-item label="职位描述:" class="s-form-item">
              <el-input type="textarea" :rows="5" v-model="speechcraftArr.jobDesc"></el-input>
            </el-form-item>
          </div>
          <div style="display: flex;margin-bottom: 5px;">
            <el-form-item label="薪资福利:"  class="s-form-item">
              <el-input type="textarea" :rows="5" v-model="speechcraftArr.wageDesc"></el-input>
            </el-form-item>
            <el-form-item label="人员构造:" class="s-form-item">
              <el-input type="textarea" :rows="5" v-model="speechcraftArr.peopleDesc"></el-input>

            </el-form-item>
          </div>
           <div style="display: flex;margin-bottom: 5px;">

              <el-form-item label="就餐事宜:" class="s-form-item">
                <el-input type="textarea" :rows="5" v-model="speechcraftArr.mealDesc"></el-input>
              </el-form-item>
              <el-form-item label="交通方式:"  class="s-form-item">
                <el-input type="textarea" :rows="5" v-model="speechcraftArr.trafficDesc"></el-input>
              </el-form-item>

           </div>
          <div style="display: flex;margin-bottom: 5px;">

            <el-form-item label="工作环境:" >
              <el-checkbox-group
                  v-model="checkedWorkEnvironmentArr"
                 >
                  <el-checkbox v-for="item in workEnvironmentArr" :label="item" :key="item">{{item}}</el-checkbox>
                </el-checkbox-group>
                <el-input type="textarea" v-model="speechcraftArr.workEnvOtherDesc" class="s-form-item" placeholder="其他说明"></el-input>
            </el-form-item>

          </div>
          <div style="display: flex;margin-bottom: 5px;">
            <el-form-item label="工衣要求:" >
              <el-checkbox-group
                  v-model="checkedWorkClothesArr"
                 >
                  <el-checkbox v-for="item in workClothesArr" :label="item" :key="item">{{item}}</el-checkbox>
                </el-checkbox-group>
                <el-input type="textarea" v-model="speechcraftArr.workClothesOtherDesc" class="s-form-item" placeholder="其他说明"></el-input>
            </el-form-item>
          </div>


          <div style="display: flex;margin-bottom: 5px;">
            <el-form-item label="住宿环境:"  >
              <el-checkbox-group
                  v-model="checkedAccommodationArr"
                 >
                  <el-checkbox v-for="item in accommodationArr" :label="item" :key="item">{{item}}</el-checkbox>
                </el-checkbox-group>
                <el-input type="textarea" v-model="speechcraftArr.accommodationOtherDesc" class="s-form-item" placeholder="其他说明"></el-input>
            </el-form-item>

          </div>
          <div style="display: flex;margin-bottom: 5px;">
            <el-form-item label="内部设施:"  >
              <el-checkbox-group
                  v-model="checkedEquipmentArr"
                 >
                  <el-checkbox v-for="item in equipmentArr" :label="item" :key="item">{{item}}</el-checkbox>
                </el-checkbox-group>
                  <el-input type="textarea" v-model="speechcraftArr.equipmentOtherDesc" class="s-form-item" placeholder="其他说明"></el-input>
            </el-form-item>

          </div>

          <el-form-item label="周边环境:" >
            <el-checkbox-group
                v-model="checkedEnvironmentArr">
                <el-checkbox v-for="item in environmentArr" :label="item" :key="item">{{item}}</el-checkbox>
              </el-checkbox-group>
                <el-input type="textarea" v-model="speechcraftArr.environmentOtherDesc" class="s-form-item" placeholder="其他说明"></el-input>
          </el-form-item>


        </el-form-item>


        <div class="btn">
          <el-button @click.native="submitForm('info')" type="primary">
            提 交 修 改
          </el-button>
        </div>
      </el-form>
    </div>
    <el-dialog title="选择福利" :visible.sync="dialogVisible1" width="40%">
      <div class="modal">
        <div class="contents">
          <el-checkbox-group v-model="checkedTags" :min="0" :max="15">
            <el-checkbox
              v-for="(item, index) in tagList"
              :label="item[0]"
              :key="index"
              @change="checkedTag(item[1])"
              >{{ item[1] }}</el-checkbox
            >
          </el-checkbox-group>
          <div class="submit" @click="submit">提交</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import MyUpload from "@/components/upload/index";
import commonMethod from '@/utils/util.js';
const initObj = {
  settlement:"866",
  settlement_cn:""
}
export default {
  components: {
    MyUpload,
  },
  data() {
    return {
      companyList:[],
      contractList:[],
      district:[],
      rules: {
        companyname: [
          {
            required: true,
            message: "请选择工厂",
            trigger: "blur",
          },
        ],
        jobs_name: [
          {
            required: true,
            message: "请输入职位名称",
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: "请选择职位类别",
            trigger: "change",
          },
        ],
        district: [
          {
            required: true,
            message: "请输入地区选择",
            trigger: "change",
          },
        ],
        checkedTags_cn: [
          {
            required: true,
            message: "请输入福利待遇",
            trigger: "blur",
          },
        ],
        nature: [
          {
            required: true,
            message: "请输入工作性质",
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入招聘人数",
            trigger: "blur",
          },
        ],
        contents: [
          {
            required: true,
            message: "请输入职位描述",
            trigger: "blur",
          },
          {
            min: 10,
            max: 1000,
            message: "长度在 10 到 1000 个字符",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入工作地点",
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
        ],
        minage: [
          {
            required: true,
            message: "请输入最低年龄",
            trigger: "blur",
          },
        ],
        maxage: [
          {
            required: true,
            message: "请输入最高年龄",
            trigger: "blur",
          },
        ],
      },
      //结算方式
      settlement: {
        list: [],
        index: 0,
        id: "",
        cn: "",
      },

      //薪资时间单位
      waydate: {
        list: [
          { id: 1, name: "时" },
          { id: 2, name: "天" },
          { id: 3, name: "周" },
          { id: 4, name: "月" },
        ],
        id: "",
        cn: "请选择薪资时间单位",
      },
      categoryList: [],
      locationList: [],
      natureList: [],
      talentList: [],
      educationList: [],
      experienceList: [],
      tagList: [],
      checkedTags: [],
      dynamicTags: [],
//添加信息
      info: {
        jobs_name:"",//职位名称
        companyname:"",
        company_id:"",
        nature:"",
        nature_cn:"",
        amount:"",
        district:[],//临时参数
        district1:"",
        district_cn1:"",
        district2:"",
        district_cn2:"",
        district3:"",
        district_cn3:"",
        checkedTags_cn:"",
        tag:[],
        tag_cn:[],
        minwage:0,
        maxwage:0,
        minage: 0,
        maxage: 0,
        negotiable: 0,
        time_unit: "",
        settlement:"",
        settlement_cn:"",
        salary_months:"",
        contents:"",//职位描述
        department:"",
        imgwork: "",
        enterprise_id:1,
        enterprisename:"宏嘉人力资源有限公司",
        jobtype:"",//岗位类型：1主推，2热招
        workfulldays:"",//满勤
        restdays:"",//月休
        agentprice:"",//代理价格
        feelong:"",//天
        contract_id:"",//合同台账
        speechcraft:[]
      },
      uploadPara:"",
      showUploadComponent:"",
      //工作环境
      checkedWorkEnvironmentArr:[],
      workEnvironmentArr:[
        '坐班','站班','低温车间','恒温车间','高温车间','车间有风扇','车间有空调','车间无异味','车间轻微异味','车间重度异味','车间无粉尘',
        '车间轻微粉尘','车间重度粉尘','车间无油污','车间轻微油污','车间重度油污','干燥车间','湿润车间','车间无噪音','车间轻微噪音','车间重度噪音',
        '静压车间','低压车间','高压车间'
      ],
      //工衣要求
      checkedWorkClothesArr:[],
      workClothesArr:['便装', '西装', '正装',
       '企业制服or工装','工装马甲','口罩','安全帽','隔离面具','防护眼镜','防护服','隔热防护服','化学防护服','气密型防护服',
       '电磁辐射防护服','防尘防护服','防静电防护服','防寒防护服','无尘无菌净化服'],

      //住宿环境
      checkedAccommodationArr: [],
      accommodationArr: ['宿舍在企业内', '宿舍在企业外', '企业附近有出租屋',
       '独立卫生间','24小时热水','有WIFI','有空调','有洗衣机','有彩电','个人独立房间','上床下桌','上下床','拼床'],

      //内部设施
      checkedEquipmentArr: [],
      equipmentArr: ['便利店', '篮球场', '足球场', '操场','羽毛球场','乒乓球室','健身器材','KTV'],
      //周边环境
      checkedEnvironmentArr: [],
      environmentArr: ['公交车站', '生活用品店', '便利店', '按摩店','棋牌室','网吧','KTV','大排档',
      '饭馆','烧烤店','出租屋','菜市场','成衣店','鞋店','眼镜店','书店','手机店'],

      //话术
      speechcraftArr:{
        jobDemand:'',//岗位要求
        jobDesc:"",//职位描述
        wageDesc:"",//薪资福利
        peopleDesc:"",//人员构造
        mealDesc:"",//就餐事宜
        trafficDesc:"",//交通方式
        workEnvOtherDesc:"",//工作环境其他说明
        workClothesOtherDesc:"",//工衣要求
        accommodationOtherDesc:"",//住宿其他说明
        equipmentOtherDesc:"",//内部设施其他说明
        environmentOtherDesc:"",//周边环境其他说明
      },




      talentName: "",
      educationName: "",
      experienceName: "",
      natureId: "",
      nature_cn: "",
      dialogVisible1: false,
      face: false,
      custom: false,
      inputVisible: false,
      inputValue: "",
      welfareTag: "",
      useTime:{
        comeTime:"",
        leaveTime:"",
        submitTime:""
      },


    };
  },
  created() {
      // this.$util.uploadFileBridge((val) => {
      //     this.uploadPara = val;
      //     this.showUploadComponent = true;
      // })
      //进入时间
      this.useTime.comeTime = commonMethod.Utils.currentTime()
     // console.log("当前时间", this.useTime.comeTime)
  },

  activated() {
    this.info.id = this.$route.query.id;
    //获取工厂
    this.gets("oasystem/catecompanylist",{type:1}).then((res) => {
      this.companyList = res.data.data;
    });


    //获取职位详情
    if(this.info.id && typeof(this.info.id) !=undefined && this.info.id !='undefined') {
      this.getInfo()
    }
    //筛选条件
    this.gets("category/indexpz").then((res) => {
      let list = res.data.data;
      this.natureList = Object.entries(list.nature);//工作类型

      this.tagList = Object.entries(list.tag);//福利
      this.locationList = list.district;//地区
      let settlement = [];//结算方式
      for (const key in list.settlement) {
        let item = { id: key, name: list.settlement[key] };
        settlement.push(item);
      }
      this.settlement.list = settlement;
      this.categoryList = list.jobs;

      this.educationList = Object.entries(list.education);
      this.experienceList = Object.entries(list.experience);
    });

  },
  destroyed() {
    //console.log("页面卸载");
    this.useTime.leaveTime = commonMethod.Utils.currentTime();
    if(this.info.id) {
      this.visitPage(11, '后台修改')
    }else{
      this.visitPage(10, '后台发布')
    }

  },
  methods: {
    //获取合同台账
    getContractList(company_id='') {
      //获取合同台账
      if(company_id) {
        let param = {
          company_id:company_id
        }
        this.gets("category/contractlist",param).then((res) => {
          this.contractList = res.data.data;
        });
      }

    },
    waydateClick(index) {
      let { id, name } = this.waydate.list[index];
      this.waydate.cn = name;
      this.waydate.id = id;
      this.info.time_unit = id;
    },
    settlementClick(index) {
      let { id, name } = this.settlement.list[index];
      this.settlement.cn = name;
      this.settlement.id = id;
      this.info.settlement = id;
      this.info.settlement_cn = name;
    },
    getInfo() {
      this.gets("jobs/jobsEdit?id=" + this.info.id).then((res) => {
        let info = res.data.data;
        console.log("职位详情",info)

        //info.minage = Number(res.data.data.jobs.age[0]);
        //info.maxage = res.data.data.jobs.age[1];
        this.settlement.id = info.settlement;
        this.settlement.cn = info.settlement_cn;
        let waydateItem = this.waydate.list.find((e) => e.id == info.time_unit);
        this.waydate.cn = waydateItem.name;//结算方式
        this.waydate.id = waydateItem.id;
        info.checkedTags_cn = info.tag_cn.join(",") || "";//逗号连接
        this.nature_cn = info.nature_cn
        let imgwork =info.imgwork.join(",")
        info.imgwork = imgwork;

        this.info = info;


        let tag = info.tag || "";
        let newArr4 = tag;//.split(",");
        let newArr5 = [];
        for (const key in newArr4) {
          if (newArr4[key]) {
            newArr5.push(newArr4[key]);
          }
        }

        //this.info.tag = newArr5;
        this.checkedTags = newArr5;

        let newArr2 = info.district;//.split(".");
        let newArr3 = [];
        for (const key in newArr2) {
          if (newArr2[key]) {
            newArr3.push(Number(newArr2[key]));
          } else {
            newArr3.push(Number(newArr2[1]));
          }
        }
        this.district = newArr3;
        this.info.address = info.address;

        this.natureId = info.nature;
        if (info.negotiable) {
          this.info.negotiable = info.negotiable;
          this.face = true;
        } else {
          this.info.negotiable = 0;
          this.face = false;
        }
        if (info.tagezd) {
          this.custom = true;

          this.dynamicTags = info.tagezd;
        } else {
          this.custom = false;
        }

        let speechcraft = info.speechcraft

        for(let i=0;i<speechcraft.length;i++) {

          if(speechcraft[i]['firsttype']=='岗位要求') {
            this.speechcraftArr.jobDemand = speechcraft[i]['secondtype']
          }
          if(speechcraft[i]['firsttype']=='职位描述') {
            this.speechcraftArr.jobDesc = speechcraft[i]['secondtype']
          }
          if(speechcraft[i]['firsttype']=='薪资福利') {
            this.speechcraftArr.wageDesc = speechcraft[i]['secondtype']
          }
          if(speechcraft[i]['firsttype']=='人员构造') {
            this.speechcraftArr.peopleDesc = speechcraft[i]['secondtype']
          }
          if(speechcraft[i]['firsttype']=='就餐事宜') {
            this.speechcraftArr.mealDesc = speechcraft[i]['secondtype']
          }
          if(speechcraft[i]['firsttype']=='交通方式') {
            this.speechcraftArr.trafficDesc = speechcraft[i]['secondtype']
          }
        }

        this.getContractList(info.company_id);//获取对应的合同

      });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this;
          console.log(this.checkedTags);
          console.log(this.info.checkedTags_cn)

          let speechcraftArr = [];

          if(this.speechcraftArr.jobDemand) {
            let temp = {
              firsttype:"岗位要求",
              secondtype:this.speechcraftArr.jobDemand
            }
            speechcraftArr.push(temp)
          }
          if(this.speechcraftArr.jobDesc) {
            let temp = {
              firsttype:"职位描述",
              secondtype:this.speechcraftArr.jobDesc
            }
            speechcraftArr.push(temp)
          }
          if(this.speechcraftArr.wageDesc) {
            let temp = {
              firsttype:"薪资福利",
              secondtype:this.speechcraftArr.wageDesc
            }
            speechcraftArr.push(temp)
          }
          if(this.speechcraftArr.peopleDesc) {
            let temp = {
              firsttype:"人员构造",
              secondtype:this.speechcraftArr.peopleDesc
            }
            speechcraftArr.push(temp)
          }
          if(this.speechcraftArr.mealDesc) {
            let temp = {
              firsttype:"就餐事宜",
              secondtype:this.speechcraftArr.mealDesc
            }
            speechcraftArr.push(temp)
          }
          if(this.speechcraftArr.trafficDesc) {
            let temp = {
              firsttype:"交通方式",
              secondtype:this.speechcraftArr.trafficDesc
            }
            speechcraftArr.push(temp)
          }
          let str;
          //工作环境
           str = this.checkedWorkEnvironmentArr.join();
          if(str) {
            str = str + "\n\t";
          }
          if( this.speechcraftArr.workEnvOtherDesc) {
            str = this.speechcraftArr.workEnvOtherDesc;
          }
          if(str) {
            let temp = {
              firsttype:"工作环境",
              secondtype: str
            }
            speechcraftArr.push(temp)
          }

          //工衣要求
           str = this.checkedWorkClothesArr.join();
          if(str) {
            str = str + "\n\t";
          }
          if( this.speechcraftArr.workClothesOtherDesc) {
            str = this.speechcraftArr.workClothesOtherDesc;
          }
          if(str) {
            let temp = {
              firsttype:"工衣要求",
              secondtype: str
            }
            speechcraftArr.push(temp)
          }


          //住宿环境
           str = this.checkedAccommodationArr.join();
          if(str) {
            str = str + "\n\t";
          }
          if( this.speechcraftArr.accommodationOtherDesc) {
            str = this.speechcraftArr.accommodationOtherDesc;
          }
          if(str) {
            let temp = {
              firsttype:"住宿环境",
              secondtype: str
            }
            speechcraftArr.push(temp)
          }
          //内部设施
           str = this.checkedEquipmentArr.join();
          if(str) {
            str = str + "\n\t";
          }
          if( this.speechcraftArr.equipmentOtherDesc) {
            str = this.speechcraftArr.equipmentOtherDesc;
          }
          if(str) {
            let temp = {
              firsttype:"内部设施",
              secondtype: str
            }
            speechcraftArr.push(temp)
          }

          //周边环境
           str = this.checkedEnvironmentArr.join();
          if(str) {
            str = str + "\n\t";
          }
          if( this.speechcraftArr.environmentOtherDesc) {
            str = this.speechcraftArr.environmentOtherDesc;
          }
          if(str) {
            let temp = {
              firsttype:"周边环境",
              secondtype: str
            }
            speechcraftArr.push(temp)
          }
          if(speechcraftArr.length>0) {
            this.info.speechcraft = speechcraftArr

          }

          this.info.tag = this.checkedTags.toString();//逗号连接
          this.info.tag_cn = this.info.checkedTags_cn;
          this.info.tagezd = this.dynamicTags;

          this.info.settlement = this.settlement.id ;
          //this.info.district = this.district.pop();

          // console.log(this.info);
          // return;

          this.useTime.submitTime = commonMethod.Utils.currentTime();
         

          this.post("jobs/addJobs", this.info).then((res) => {
          //  console.log(res);
          
            that.useTime.leaveTime = commonMethod.Utils.currentTime();
            
            if(that.info.id) {
              that.visitPage(11, '后台修改')
            }else{
              that.visitPage(10, '后台发布')
            }
          
          
            if (res.data.code == 1) {
              Message.success(res.data.msg);

              setTimeout(function () {
                that.$router.go(-1);
              }, 1000);
            } else {
              Message.error(res.data.msg);
            }
          });
        } else {
          Message.error("请填写完整信息");
          return false;
        }
      });
    },
   //选择工厂
    chooseCompany(val1, val2) {
      this.info.company_id = val1;
      this.info.companyname = val2;
      this.getContractList(this.info.company_id);//获取台账列表
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        if (this.dynamicTags.length >= 3) {
          Message.warning("自定义福利最多填写三个");
        } else {
          this.dynamicTags.push(inputValue);
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    //福利选择
    checkedTag(val) {
      console.log("选择福利",val)
      if (!this.info.checkedTags_cn) {
        this.info.checkedTags_cn = val;
        return;
      }
      let temp = this.info.checkedTags_cn.split(",");
      let index = temp.findIndex((e) => e == val);
      if (index == -1) {
        temp.push(val);
      } else {
        temp.splice(index, 1);
      }
      this.info.checkedTags_cn = temp.toString();
    },
    //提交
    submit() {
      this.dialogVisible1 = false;
    },
    tagsClick() {
      this.dialogVisible1 = true;
    },
    //面议
    handleswitch(e) {
      console.log(e);
      if (e) {
        this.info.negotiable = 1;
      } else {
        this.info.negotiable = 0;
      }
    },
    //经验要求
    ExpChoosen(val1, val2) {
      console.log(val1, val2);
      this.info.experience = val1;
      this.info.experience_cn = val2;
    },
    //学历要求
    EduChoosen(val1, val2) {
      console.log(val1, val2);
      this.info.education = val1;
      this.info.education_cn = val2;
      this.educationName = val2;
    },

    //性质
    natureChoose(val1, val2) {
      this.natureId = val1;
      this.nature_cn = val2;
      this.info.nature = val1;
      this.info.nature_cn = val2;
      if(/兼职|临时工/.test(this.nature_cn)){
        this.info.negotiable = 0
        this.face = false

      }
    },
    //选择职位类别
    handlecategory(e) {
      this.info.category1 = e[0]
      this.info.category2 = e[1]
      this.info.category3 = e[2]

      let info = this.$refs["cascaderJobType"]
        .getCheckedNodes()[0].pathLabels;
      this.info.category_cn = info;
      this.info.category_cn1 = info[0]
      this.info.category_cn2 = info[1]
      this.info.category_cn3 = info[2]
    },
    handleChange() {
      //console.log(this.info.district)
      this.info.district1 = this.info.district[0];
      this.info.district2 = this.info.district[1];
      this.info.district3 = this.info.district[2];

      let info = this.$refs["cascaderAddr"]
        .getCheckedNodes()[0].pathLabels;
      this.info.district_cn1 = info[0]
      this.info.district_cn2 = info[1]
      this.info.district_cn3 = info[2]


      // this.info.district_cn = this.$refs["cascaderAddr"]
      //   .getCheckedNodes()[0]
      //   .pathLabels.join(",");
    },
    uploadImgSuccess(url, key) {
      if (name == 'imgwork') {
           this.info[key] = url ? url.split(',') : [];
      } else {
          //this.goodVideoList = url ? url.split(',') : [];
          this.info[key] = url;
      }

    },
    visitPage(type,name) {
      let params = {
      				name:name,//临时参数
      				type:type,
      				comeTime: this.useTime.comeTime,
      			  leaveTime: this.useTime.leaveTime,
      			  submitTime: this.useTime.submitTime,
      			}
      this.post('operate/logAdd',params).then(res=>{
        this.useTime.submitTime = ''
      })

    }

  },
};
</script>

<style lang="scss">
  .s-form-item{
    width: 700px;
  }
.natureItems_box {
  display: flex;
}
.jobsAdd .el-checkbox{
  width: auto;
}
.natureItems {
  width: 107px;
  height: 50px;
  border: 1px solid #bfcbd2;
  border-radius: 4px;
  color: #bfcbd2;
  line-height: 50px;
  margin-right: 51px;
  text-align: center;
  cursor: pointer;
}

.active {
  color: #fff;
  background: #1e8fff;
}
.experiences {
  width: 600px;
  height: 40px;
  border: 1px solid #dcdfe6;
  line-height: 40px;
  padding-left: 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  padding-right: 15px;
}
.el-dropdown {
  width: 100%;
}
.el-dropdown-link {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/jobsManage/addCompanyJobs.vue